// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
export const typography = {
  pulseH1Sbold: {
    fontSize: "24px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "36px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH2Med: {
    fontSize: "21px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "31.5px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH2Sbold: {
    fontSize: "21px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "31.5px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH3Med: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH3Sbold: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH1SboldInter: {
    fontSize: "24px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "36px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH2MedInter: {
    fontSize: "21px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "31.5px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH2SboldInter: {
    fontSize: "21px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "31.5px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH3MedInter: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseH3SboldInter: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulsePrimaryReg: {
    fontSize: "16px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulsePrimaryMed: {
    fontSize: "16px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulsePrimaryLink: {
    fontSize: "16px",
    textDecoration: "underline",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryReg: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryMed: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryLink: {
    fontSize: "14px",
    textDecoration: "underline",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelReg: {
    fontSize: "12px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelMed: {
    fontSize: "12px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelLink: {
    fontSize: "12px",
    textDecoration: "underline",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.12px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulsePrimaryRegInter: {
    fontSize: "16px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulsePrimaryMedInter: {
    fontSize: "16px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulsePrimaryLinkInter: {
    fontSize: "16px",
    textDecoration: "underline",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "19.2px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryRegInter: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryMedInter: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseSecondaryLinkInter: {
    fontSize: "14px",
    textDecoration: "underline",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelRegInter: {
    fontSize: "12px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.12px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelMedInter: {
    fontSize: "12px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.12px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseLabelLinkInter: {
    fontSize: "12px",
    textDecoration: "underline",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.12px",
    lineHeight: "14.4px",
    paragraphIndent: "0px",
    paragraphSpacing: "8px",
    textCase: "none",
  },
  pulseButtonMed: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseTableheaderSbold: {
    fontSize: "13px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "15.6px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseButtonMedInter: {
    fontSize: "14px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "16.8px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseTableheaderSboldInter: {
    fontSize: "13px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "0px",
    lineHeight: "15.6px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS1Sbold: {
    fontSize: "36px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "54px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS2Sbold: {
    fontSize: "24px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "36px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS3Sbold: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS1SboldInter: {
    fontSize: "36px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "54px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS2SboldInter: {
    fontSize: "24px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.12px",
    lineHeight: "36px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
  pulseS3SboldInter: {
    fontSize: "18px",
    textDecoration: "none",
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    letterSpacing: "-0.5px",
    lineHeight: "27px",
    paragraphIndent: "0px",
    paragraphSpacing: "0px",
    textCase: "none",
  },
};

export type TypographyPropsVariantOverrides = {
  [K in keyof typeof typography]: true;
};

export type Typography = typeof typography;
